import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import ProjectDetail from "./components/Projects/ProjectDetail";
import Footer from "./components/Footer";
import Contact from "./components/Contact/Contact";
import StyleDesign from "./components/Quiz/StyleDesign";
import Quiz from "./components/Quiz/Quiz";

import { SpeedInsights } from "@vercel/speed-insights/react";
import { Analytics } from "@vercel/analytics/react";
import ReactGA from "react-ga4";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

ReactGA.initialize("G-T9487JX6HE");

ReactGA.send({
  hitType: "pagewiew",
  page: window.location.pathname
});


function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/project/:projectname" element={<ProjectDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/defineyourstyle" element={<StyleDesign />} />
          <Route path="/defineyourstyle/quiz" element={<Quiz />} />
          <Route path="*" element={<Navigate to="/"/>} />
        </Routes>
        <Footer />
        <SpeedInsights />
     <Analytics/>
      </div>
    </Router>
  );
}

export default App;
